import styled from 'styled-components';

import Link from 'components/link';

export const StyledLink = styled(Link)`
  text-decoration: underline;
`;
